export default "__VITE_ASSET__DzBAG4Dp__"